import styled from "styled-components/macro";

import { Wrapper } from "./Cell";

export const TitleCellWrapper = styled(Wrapper)`
  position: relative;
  align-items: center;
  z-index: 1;
  height: 32px;
  border-bottom: none;
  &:hover {
    z-index: 5;
  }
  &:not(:first-child)::before {
    content: "";
    position: absolute;
    top: 7px;
    bottom: 7px;
    width: 1px;
    background: #bec3c7;
    left: 0;
  }
`;
